/**
 * Gate I8: Workflow Dashboard API Fetch Wrapper
 */

import type { WorkflowDashboardResponse } from './workflow-types';

export interface WorkflowDashboardParams {
  location?: string | null;
  species?: string | null;
}

export async function fetchWorkflowDashboard(
  params: WorkflowDashboardParams = {}
): Promise<WorkflowDashboardResponse> {
  const searchParams = new URLSearchParams();
  
  if (params.location && params.location !== 'all') {
    searchParams.set('location', params.location);
  }
  if (params.species && params.species !== 'all') {
    searchParams.set('species', params.species);
  }
  
  const queryString = searchParams.toString();
  const url = `/api/behavior/workflow-dashboard${queryString ? `?${queryString}` : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Failed to fetch workflow dashboard: ${response.status}`);
  }
  
  return response.json();
}
